export { Checkbox } from "@mantine/core";
export type { CheckboxProps, CheckboxGroupProps } from "@mantine/core";
export { checkboxOverrides } from "./Checkbox.config";
